import React from 'react';
import Imgix from "react-imgix";
import {AVATAR_PATH} from "../../common/constants";
import {useAppSelector} from "../../creator-presets/DAL/store";
import {format} from "date-fns";
import {getEpochFromDate} from "../../common/services/logic-provider";
import VerifiedIcon from "../../../../ui/svg/common/verified";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";

export interface IPresetCreatorDetailsProps {
    cancelImgLazyload?:boolean;

}
const CreatorDetails = (props:IPresetCreatorDetailsProps) => {

    const PresetPageData = useAppSelector((store) => store.PresetPageData);
    const mainPreset = useAppSelector((store) => store.mainPreset);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);

    return (
        <div className="w-full">
            <div className="w-full flex items-center">
                <div className="w-8 h-8 mr-2">
                    {PresetPageData.profile.imgExt.length > 0 ?
                        <Imgix
                            src= {imgCdnDomain + "/" +
                                  creatorsPath +
                                  PresetPageData.profile.prfUserGUID + "."  +
                                  PresetPageData.profile.imgExt  + "?epoch=" + getEpochFromDate(PresetPageData.profile.itemModifiedWhen)}
                            sizes={"auto"}
                            width={200}
                            height={200}
                            imgixParams={{ mask:"ellipse" }}
                            htmlAttributes={{
                                alt: `${PresetPageData.profile.handle} profile image`,
                                loading: props.cancelImgLazyload ? undefined : 'lazy',
                            }}

                        />
                        :
                        <Imgix
                            src= {imgCdnDomain + AVATAR_PATH}
                            sizes={"auto"}
                            width={200}
                            height={200}
                            imgixParams={{ fit: "facearea",facepad:"1.9",mask:"ellipse" }}
                            htmlAttributes={{
                                alt: `${PresetPageData.profile.handle} profile image`,
                                loading: props.cancelImgLazyload ? undefined : 'lazy',
                            }}
                        />
                    }
                </div>
                <div className="text-base pr-2 xl:pr-4 flex items-center">
                    <span>{PresetPageData.profile.publicName}</span>
                    {PresetPageData.profile.isVerified &&
                        <div className="ml-2">
                            <VerifiedIcon width="15px" />
                        </div>
                    }
                </div>
                <div className="xl:text-base pr-2 xl:pr-4">
                    <a className="text-black"
                       onClick={(evt) => {
                           sendGAEvent('Click', "Profile : " + PresetPageData.profile.handle);
                       }}
                       href={"/studioverse/creator/" + PresetPageData.profile.handle.toLowerCase()}>
                        @{PresetPageData.profile.handle}
                    </a>
                </div>
                <div className="xl:text-base pr-2 xl:pr-4">|</div>
                <div className="xl:text-base">
                    {format(new Date(mainPreset.createDate), 'MMM d, yyyy')}
                </div>
            </div>
            <div className="w-full pt-4 md:w-3/4">{mainPreset.description}</div>

        </div>
    )
};

export default CreatorDetails;